import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import ModuleList from './ModuleList';

const ModuleListPage = () => {
    const navigate = useNavigate();
    const { permissions: accountPermissions } = useAccount();
    const { t } = useTranslation('moduleList');

    const extra = hasPermissions(accountPermissions, [permissionKind.createModule]) ? (
        <Button icon={<PlusOutlined />} onClick={() => navigate('/admin/system/modules/add')} type="primary">
            {t('moduleList:actions.newModule')}
        </Button>
    ) : null;

    return (
        <ConsolePageWithHeader extra={extra} title={t('moduleList:title')}>
            <ModuleList />
        </ConsolePageWithHeader>
    );
};

export default ModuleListPage;
